var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MenuItem } from "@headlessui/react";
import { PlusCircleIcon, StarIcon as StarIconOutline, } from "@heroicons/react/24/outline";
import { ChevronDownIcon, StarIcon } from "@heroicons/react/24/solid";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { clsx } from "clsx";
import { toast } from "react-toastify";
import { setPipelinePrimaryRequest } from "../../../api/api";
import { OPEN_NEW_PIPELINE_MODAL, PIPELINE_SET_PRIMARY, } from "../../../constants";
import { ActivePipelineContext } from "../../../providers/ActivePipelineContextProvider";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { PipelinesContext } from "../../../providers/PipelinesContextProvider";
import { WPQTIconButton } from "../../common/Button/Button";
import { WPQTDropdown } from "../WPQTDropdown";
function PipelineSelectionDropdown() {
    const { state: { activePipeline }, fetchAndSetPipelineData, } = useContext(ActivePipelineContext);
    const { state: { pipelines }, pipelinesDispatch, } = useContext(PipelinesContext);
    const { modalDispatch } = useContext(ModalContext);
    const changePipelinePrimary = (pipeline) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield setPipelinePrimaryRequest(pipeline.id);
            pipelinesDispatch({
                type: PIPELINE_SET_PRIMARY,
                payload: pipeline.id,
            });
        }
        catch (e) {
            console.error(e);
            toast.error(__("Failed to set primary board", "quicktasker"));
        }
    });
    const openPipelineModal = () => __awaiter(this, void 0, void 0, function* () {
        modalDispatch({
            type: OPEN_NEW_PIPELINE_MODAL,
        });
    });
    return (_jsxs(WPQTDropdown, { menuBtnClasses: "wpqt-flex wpqt-cursor-pointer wpqt-items-center wpqt-gap-1 wpqt-rounded-xl wpqt-border wpqt-border-solid wpqt-border-qtBorder wpqt-p-3", menuBtn: ({ active }) => (_jsxs(_Fragment, { children: [_jsx("div", { className: "wpqt-leading-none", children: activePipeline === null || activePipeline === void 0 ? void 0 : activePipeline.name }), _jsx(ChevronDownIcon, { className: `wpqt-size-4 ${active ? "wpqt-text-qtBlueHover" : ""}` })] })), children: [_jsx("div", { className: "wpqt-mb-4 wpqt-text-center wpqt-font-bold", children: __("Change board", "quicktasker") }), pipelines.map((existingPipeline) => {
                const isPrimary = existingPipeline.is_primary;
                const isCurrentPipeline = (activePipeline === null || activePipeline === void 0 ? void 0 : activePipeline.id) === existingPipeline.id;
                return (_jsx(MenuItem, { children: _jsxs("div", { className: "wpqt-mb-3 wpqt-flex wpqt-gap-2", children: [_jsx("div", { className: clsx("wpqt-cursor-pointer wpqt-text-center", {
                                    "wpqt-font-bold": isCurrentPipeline,
                                }), onClick: () => fetchAndSetPipelineData(existingPipeline.id), children: existingPipeline.name }), _jsx("div", { className: "wpqt-ml-auto", children: isPrimary ? (_jsx(StarIcon, { className: "wpqt-size-4 wpqt-cursor-pointer wpqt-text-blue-500" })) : (_jsx(StarIconOutline, { className: "wpqt-size-4 wpqt-cursor-pointer wpqt-text-gray-400", onClick: (e) => {
                                        e.stopPropagation();
                                        changePipelinePrimary(existingPipeline);
                                    } })) })] }) }, existingPipeline.id));
            }), _jsx(MenuItem, { children: _jsx("div", { className: "wpqt-mt-4 wpqt-flex wpqt-cursor-pointer wpqt-items-center wpqt-gap-2", children: _jsx(WPQTIconButton, { text: __("Add new board", "quicktasker"), onClick: openPipelineModal, icon: _jsx(PlusCircleIcon, { className: "wpqt-size-6 wpqt-icon-green" }), className: "wpqt-bg-white hover:!wpqt-bg-gray-100" }) }) }, "new-pipeline")] }));
}
export { PipelineSelectionDropdown };
